module.exports = __webpack_public_path__ + "media/svg/vector-6d8b1084.svg";